<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/oZJZCu/tc-custom/9780062652874.jpg?1718106102580" alt="This image is the cover for the book Heart of Iron"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heart of Iron
      </h1>
      <p class="bookDescription body article font2">
        <p><b>*A 2019 Rainbow Book List Selection*</b></p><p><b>An action-packed tale full of romance, royalty, and adventure, inspired by the story of <i>Anastasia</i>. Perfect for fans of <i>Six of Crows,</i><i>Cinder</i>, and the cult classic television show <i>Firefly</i>.</b></p><p>Seventeen-year-old Ana is a scoundrel by nurture and an outlaw by nature. Found as a child drifting through space with a sentient android called D09, Ana was saved by a fearsome space captain and the grizzled crew she now calls family. But D09—one of the last remaining illegal Metals—has been glitching, and Ana will stop at nothing to find a way to fix him.</p><p>Ana’s desperate effort to save D09 leads her on a quest to steal the coordinates to a lost ship that could offer all the answers. But at the last moment, a spoiled Ironblood boy beats Ana to her prize. He has his own reasons for taking the coordinates, and he doesn’t care what he’ll sacrifice to keep them.</p><p>When everything goes wrong, she and the Ironblood end up as fugitives on the run. Now their entire kingdom is after them—and the coordinates—and not everyone wants them captured alive.</p><p>What they find in a lost corner of the universe will change all their lives—and unearth dangerous secrets. But when a darkness from Ana’s past returns, she must face an impossible choice: does she protect a kingdom that wants her dead or save the Metal boy she loves? </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ashley Poston
      </h2>
      
      <p class="authorDescription body article"><B>Ashley Poston</B> loves dread pirates, moving castles, and starry night skies. When not lost in a book, she&#8217;s lost in real life, searching for her next great adventure. She is the author of <I>Heart of Iron</I> and its sequel,&#160;<I>Soul of Stars</I>, as well as the Once Upon a Con series. She can be found online at www.ashposton.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsPublishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?43180faa